import React from 'react';
import { Check } from 'lucide-react';
import { Button } from './Button';
import { FadeIn } from './FadeIn';
export function Modules() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  const modules = [{
    title: 'Mentalidad y Oportunidad Global',
    items: ['Cómo funciona la industria', 'Cuánto se gana realmente', 'Tipos de trabajos', 'Errores comunes', 'Ruta más rápida', 'Plan de acción inicial']
  }, {
    title: 'Licencias y Certificaciones',
    items: ['Qué necesitás sacar', 'Dónde hacerlo', 'Cómo ahorrar dinero', 'Qué sirve de verdad', 'Qué evita perder tiempo']
  }, {
    title: 'Cómo Entrar al Mercado',
    items: ['CV náutico ganador', 'Dónde buscar empleo', 'Cómo aplicar', 'Networking real', 'Cómo destacar sin experiencia']
  }, {
    title: 'Vida a Bordo y Profesionalismo',
    items: ['Qué esperan de vos', 'Rutinas reales', 'Cómo crecer rápido', 'Normas y códigos', 'Cómo escalar posiciones']
  }, {
    title: 'De Marinero a Capitán',
    items: ['Camino de crecimiento', 'Más ingresos', 'Más responsabilidades', 'Cómo llegar al timón', 'Plan a largo plazo']
  }];
  return <section className="bg-navy-950 text-white py-24" data-id="element-115">
      <div className="container mx-auto px-4" data-id="element-116">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-117">
          <FadeIn data-id="element-118">
            <h2 className="text-3xl md:text-5xl font-heading font-bold mb-6" data-id="element-119">
              ¿Qué incluye el Sistema?
            </h2>
            <p className="text-xl text-gray-400" data-id="element-120">
              <span className="text-gold-500 font-bold" data-id="element-121">5 MÓDULOS</span>{' '}
              diseñados para llevarte desde cero hasta trabajar en el mar
            </p>
          </FadeIn>
        </div>

        <div className="max-w-4xl mx-auto space-y-8" data-id="element-122">
          {modules.map((mod, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-123">
              <div className="bg-navy-900 border border-navy-800 rounded-3xl p-8 md:p-10 relative overflow-hidden group hover:border-gold-500/30 transition-colors" data-id="element-124">
                <div className="absolute top-0 right-0 w-32 h-32 bg-gold-500/5 rounded-bl-full -mr-10 -mt-10 transition-transform group-hover:scale-110" data-id="element-125"></div>

                <div className="flex flex-col md:flex-row gap-8 relative z-10" data-id="element-126">
                  <div className="md:w-1/3 flex-shrink-0" data-id="element-127">
                    <div className="text-gold-500 font-mono font-bold text-lg mb-2" data-id="element-128">
                      Módulo {index + 1}
                    </div>
                    <h3 className="text-2xl font-bold leading-tight" data-id="element-129">
                      {mod.title}
                    </h3>
                  </div>

                  <div className="md:w-2/3" data-id="element-130">
                    <ul className="grid sm:grid-cols-2 gap-4" data-id="element-131">
                      {mod.items.map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-132">
                          <Check className="w-5 h-5 text-gold-500 flex-shrink-0 mt-0.5" data-id="element-133" />
                          <span className="text-gray-300" data-id="element-134">{item}</span>
                        </li>)}
                    </ul>
                  </div>
                </div>
              </div>
            </FadeIn>)}
        </div>

        <FadeIn delay={0.2} className="text-center mt-16" data-id="element-135">
          <Button size="xl" onClick={scrollToPricing} data-id="element-136">
            👉 Quiero los 5 módulos ahora
          </Button>
        </FadeIn>
      </div>
    </section>;
}